import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutSectionCenteredComponent } from './layout-section-centered.component';

@NgModule({
  declarations: [
    LayoutSectionCenteredComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LayoutSectionCenteredComponent
  ]
})
export class LayoutSectionCenteredModule { }
